module.exports = __webpack_public_path__ + "media/application/images/features/inventory-linking-2200-b4e1f3107e31595a13820c06a09a42f4.png";